import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-inline-flex align-center text-decoration-none text-link font-weight-regular text-body-1" }
const _hoisted_2 = {
  key: 0,
  class: "ml-2"
}

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { isDesktop } from '@/app/composables/useBreakpoints'


export default {
  __name: 'LinkHome',
  setup(__props) {

const { t } = useI18n()
const label = computed(() => t('App#Logo#Title Home'))

return (_ctx, _cache) => {
  const _component_fa_icon = _resolveComponent("fa-icon")

  return (_openBlock(), _createElementBlock("a", _hoisted_1, [
    _createVNode(_component_fa_icon, { icon: ['far', 'house'] }),
    (_unref(isDesktop))
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(label.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}